import { apiGet, apiDelete } from './client';
import { ApiResponse } from '@tinyrewards/shared';

export interface IssuerIssuance {
    issuedBadgeID:   string;
    badgeID:         string;
    badgeName:       string;
    badgeImage:      string | null;
    issuerID:        string | null;
    issuerName:      string | null;
    recipientUserID: string;
    recipientEmail:  string;
    recipientName:   string | null;
    issuedDate:      string;
    expiryDate:      string | null;
    isManual:        boolean;
    isApproved:      boolean;
    isBaked:         boolean;
    isDeleted:       boolean;
}

export type IssuanceStatus = 'active' | 'revoked' | 'all';

export interface ListIssuancesParams {
    status?:   IssuanceStatus;
    badgeID?:  string;
    from?:     string;          // ISO date
    to?:       string;          // ISO date
    page?:     number;
    pageSize?: number;
}

export type ListIssuancesResponse = ApiResponse<never> & {
    rows:     IssuerIssuance[];
    total:    number;
    page:     number;
    pageSize: number;
};

export function listIssuances(params: ListIssuancesParams = {}): Promise<ListIssuancesResponse> {
    const q = new URLSearchParams();
    if (params.status)   q.set('status',   params.status);
    if (params.badgeID)  q.set('badgeID',  params.badgeID);
    if (params.from)     q.set('from',     params.from);
    if (params.to)       q.set('to',       params.to);
    if (params.page)     q.set('page',     String(params.page));
    if (params.pageSize) q.set('pageSize', String(params.pageSize));
    return apiGet<never>(`/api/rewards?${q.toString()}`) as Promise<ListIssuancesResponse>;
}

export function revokeIssuance(issuedBadgeID: string): Promise<ApiResponse<void>> {
    return apiDelete<void>(`/api/rewards/${issuedBadgeID}`);
}
